import React from "react";
import "./ImageGallery.css";

const images = [
  "/images/image5.jpg",
  "/images/image6.jpg",
  "/images/image7.jpg",
  // Continue adding paths up to image15.jpg
];

const ImageGallery = () => {
  return (
    <div className="imageGallery-container">
      {[0, 1, 2].map((rowIndex) => (
        <div key={rowIndex} className="imageGallery-track">
          {/* Duplicate images to ensure seamless loop */}
          {[...images, ...images].map((img, index) => (
            <div key={index} className="imageGallery-image">
              <img src={img} alt={`gallery-${rowIndex}-${index}`} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;